export default __webpack_public_path__ + "static/media/blank.1be72cd8.png";